module.exports = __webpack_public_path__ + "img/Shadow Squad Esport Gaming Logo.jpg";